import Box from "@mui/material/Box"
import { ReactNode } from "react"

/** The space between the two fields, in theme spacing units. */
const GAP = 1

/**
 * The outline and the link of a locked pair, and the lock icon itself (see LockAspectRatio).
 * Not the brand blue: that is kept for primary actions, and a lock is only a state.
 */
export const LOCKED_COLOR = "text.primary"

interface Props {
    width: ReactNode
    height: ReactNode
    /** the aspect ratio is locked: the two fields are shown joined */
    locked: boolean
}

/**
 * Width and height side by side. While the aspect ratio is locked they read as one: both
 * fields are outlined and a link is drawn across the gap between them.
 */
const DimensionsPair = ({ width, height, locked }: Props) => (
    <Box
        display="flex"
        gap={GAP}
        position="relative"
        sx={
            locked
                ? {
                      "& .MuiFilledInput-root": {
                          boxShadow: (theme) => `inset 0 0 0 1px ${theme.palette.text.primary}`,
                      },
                  }
                : undefined
        }
    >
        <Box flex={1} minWidth={0}>
            {width}
        </Box>
        {locked && (
            // exactly as wide as the gap, so it joins the two outlines without covering them
            <Box
                aria-hidden
                sx={{
                    position: "absolute",
                    left: (theme) => `calc(50% - ${theme.spacing(GAP / 2)})`,
                    top: "calc(50% - 1px)",
                    width: (theme) => theme.spacing(GAP),
                    height: 2,
                    bgcolor: LOCKED_COLOR,
                }}
            />
        )}
        <Box flex={1} minWidth={0}>
            {height}
        </Box>
    </Box>
)

export default DimensionsPair
